module.exports = __webpack_public_path__ + "img/img12.8dc3723b.svg";